import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal } from '../modal';

import './allPrizesModal.styl';
import { useTranslationsContext } from 'store/translations';
import { IPrizeItemConfig, prizes } from './config';
import Label from 'components/core/Label';
import { sanitize } from 'dompurify';

interface AllPrizesModalProps {
    isOpened: boolean;
    onClose: () => void;
}

export const AllPrizesModal: FC<AllPrizesModalProps> = observer(({ isOpened, onClose }) => {
    const { translate } = useTranslationsContext();

    const items = prizes.reduce((acc, x) => {
        x.items.forEach((item) => acc.push(item));
        return acc;
    }, [] as IPrizeItemConfig[]);

    const renderPrizeBlock = (prize: IPrizeItemConfig) => {
        const { id, imageUrl, count, itemNameKey } = prize;

        return (
            <div className="all-prizes-modal-info" key={id}>
                <img className="all-prizes-modal-info-image" src={imageUrl}></img>
                <div className="all-prizes-modal-content">
                    <div
                        className="all-prizes-modal-shortname"
                        dangerouslySetInnerHTML={{
                            __html: sanitize(translate(itemNameKey) + ' — ' + translate('snake.amount.draw', { count }))
                        }}
                    ></div>
                </div>
            </div>
        );
    };

    const superPrizeBlock = (
        <div className="all-prizes-modal-super-prize">
            <div className="all-prizes-modal-super-prize-amount">
                <Label isRawHtml of="superprize.amount" />
            </div>
        </div>
    );

    return (
        <>
            <Modal
                isOpened={isOpened}
                onClose={onClose}
                title="Список всех призов"
                description="В зависимости от количества собранных билетов к 25 декабря 2024 вы участвуете в розыгрыше одного вида приза"
            >
                <div className="all-prizes-modal">
                    {items.map(renderPrizeBlock)}
                    {superPrizeBlock}
                    <div className="all-prizes-modal-hint">{translate('prizes.hint')}</div>
                </div>
            </Modal>
        </>
    );
});
